import React from 'react';

const Resume = () => {
  return (
    <div>
      Resume Page
    </div>
  )
}

export default Resume;